<script>
import API from "../../../API";
import toaster from "../../common/toaster";

import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import Loading from "../../common/loading.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import TextField from "../../common/text-field.vue";
import PropertyTable from "../../common/property-table.vue";

export default {
    name: "screengroup-dialog",
    components: {PropertyTable, TextField, DialogBase, DialogHeader, Loading, DialogActionbar, DialogBody},
    data() {
        const name = Lang.langGet('Name');
        const mustEnter = Lang.langGet('You must enter a ');

        return {
            showDialog: false,
            processing: false,
            invalid: true,
            name: '',
            nameToEdit: '',
            id: undefined,
            availableScreens: {},
            selectedScreenIds: [],

            stringRules: {
                required: value => !!value || mustEnter + name
            }
        }
    },
    computed: {
        screengroupItems() {
            return Object.keys(this.availableScreens).map(screenNumber => {
                const child = this.availableScreens[screenNumber];
                const currentScreenId = child.id;
                const currentScreenName = child.fullname;
                const selected = this.selectedScreenIds.some(id => id === currentScreenId);

                return {name: currentScreenName, id: currentScreenId, children: null, selected: selected};
            });
        },
        translations() {
            return {
                placeholder: Lang.langGet('New screengroup name'),
                screenName: Lang.langGet('Screen name'),
                addScreengroup: Lang.langGet('Add new screengroup'),
                editScreengroup: Lang.langGet('Edit screengroup'),
                name: Lang.langGet('Name'),
                addedSuccessfully: Lang.langGet('Screengroup :name added successfully', {name: this.name}),
                saveError: Lang.langGet('Screengroup :name could not be added', {name: this.name}),
            }
        },
    },
    watch: {
        name(newName) {
            this.invalid = !newName;
        }
    },
    methods: {
        show() { this.showDialog = true; },
        hide() { this.showDialog = false; },
        refreshList() {
            EaseEventBus.fire('reloadScreengroupTable');
        },
        handleClose() { this.hide(); },
        handleChange(newName) {
            this.name = newName;
        },
        toggleScreenIds(screenId) {
            const index = this.selectedScreenIds.findIndex(id => id === screenId);
            if (index < 0) {
                this.selectedScreenIds.push(screenId);
            } else {
                this.selectedScreenIds.splice(index, 1);
            }
        },
        handleChangeScreen(item) {
            this.toggleScreenIds(item.id);
        },
        async updateScreengroup(publishData = null) {
            const url = this.id ? '/administration/screengroup/edit' : '/administration/screengroup/add';
            const api = new API(url);
            const data = {name: this.name, project: Laravel.activeProject, screens: this.selectedScreenIds};

            if (this.id) {
                data.id = this.id;
                if (publishData?.publish) {
                    data.publish = publishData.publish;
                }
            }

            // console.log('Saving with', data);
            const result = await api.post(data);
            // console.log('Result', result);
            this.processing = false;

            if (result.errored) {
                this.errored = true;
                // toaster.error(this.translations.saveError);
            } else {
                this.errored = false;
                toaster.success(this.translations.addedSuccessfully);
                this.refreshList();
                this.hide();
            }
        },
        async handleSave() {
            this.processing = true;

            if (this.id) { // edit
                let updatePublish = parseInt(localStorage.getItem("screengroup-publish-" + Laravel.activeProject) || 1);

                let publishData = {
                    publish: updatePublish
                };

                if (publishData.publish && !localStorage.getItem("screengroup-autopublish-confirm-" + Laravel.activeProject)) {
                    EaseEventBus.fire('showAutopublishWarning', {
                        data: publishData,
                        type: 'screengroup',
                        task: 'Save',
                        id: 'edit-screengroup'
                    });
                } else {
                    await this.updateScreengroup(publishData);
                }
            } // add
            else {
                await this.updateScreengroup();
            }
        },
        addSelectedScreens(result) {
            Object.keys(result).map(index => {
                const screenId = result[index];
                this.selectedScreenIds.push(screenId);
            });
        },
        async load() {
            this.processing = true;
            const url = '/administration/screengroup/getscreens/' + Laravel.activeProject;
            const api = new API(url);

            this.selectedScreenIds = [];

            const result = await api.get();
            this.processing = false;

            if (result.errored) {
                this.errored = true;
            } else {
                this.errored = false;

                if (this.id) {
                    const url = '/administration/screengroup/edit/data';
                    const api = new API(url);

                    const selectedScreensResult = await api.post({id: this.id});

                    this.addSelectedScreens(selectedScreensResult);
                }

                this.availableScreens = result;
            }

            // console.log('Data loaded:', this.availableScreens);
            // console.log('Items for table', this.screengroupItems);
        },
        calculateTitleAndButtonHeight() {
            let heightDialogHeader = document.getElementById('screengroup-dialog-header')?.offsetHeight;
            let heightDialogActionbar = document.getElementById('screengroup-dialog-actionbar')?.offsetHeight;
            return heightDialogHeader + heightDialogActionbar ? heightDialogHeader + heightDialogActionbar : 124;
        }
    },
    mounted: function () {
        EaseEventBus.listen('screengroupAdd', () => {
            this.id = null;
            this.nameToEdit = '';
            this.name = '';
            this.show();
            this.load();
        });

        EaseEventBus.listen('screengroupEdit', params => {
            this.id = params.id;
            this.nameToEdit = params.name || '';
            this.name = params.name || '';
            this.show();
            this.load();
        });

        EaseEventBus.listen('updateProceed', (data) => {
             if (data.type === 'screengroup' && data.task === 'Save' && data.id === 'edit-screengroup') {
                if (data.proceed) {
                    this.updateScreengroup(data.data);
                } else {
                    this.processing = false;
                }
             }
        });
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="600"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            id="screengroup-dialog-header"
            @close="handleClose"
            :title="this.id ? translations.editScreengroup : translations.addScreengroup"
        />
        <loading :loading="processing"/>
        <dialog-body class="d-flex flex-column overflow-hidden" :style="'max-height: calc(90vh - ' + calculateTitleAndButtonHeight() + 'px);'">
            <div  class="d-flex flex-column align-center justify-center overflow-hidden">
                <text-field class="pa-4 pb-0"
                    :label="translations.name"
                    :value="name"
                    :placeholder="translations.placeholder"
                    :rules="[stringRules.required]"
                    :error="invalid"
                    autofocus
                    @input="handleChange"
                />
                <div class="w-100 pa-4 pt-0 d-flex flex-column overflow-y-auto">
                    <property-table
                        :items="screengroupItems"
                        searchable
                        sorted
                        showSelCount
                        :propertyName="translations.screenName"
                        @input="handleChangeScreen"
                        disableSelectAll
                    />
                </div>
            </div>
        </dialog-body>
        <dialog-actionbar
            id="screengroup-dialog-actionbar"
            :disableSave="invalid"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>

</style>
